const KNOWN_PROVIDER_LABELS = {
  vertex_ai: "Vertex AI",
  google_ai: "Google AI",
  deterministic: "Extraction locale",
};

export const normalizeProviderName = (value, fallback = "unknown") => {
  const normalized = String(value || "").trim().toLowerCase();
  return normalized || fallback;
};

export const getProviderLabel = (value) => {
  const normalized = normalizeProviderName(value, "unknown");
  return KNOWN_PROVIDER_LABELS[normalized] || "IA";
};

export const formatProviderTitle = (providerUsed) => {
  const normalized = normalizeProviderName(providerUsed, "unknown");
  return KNOWN_PROVIDER_LABELS[normalized] || "IA";
};

export const formatProviderSubtitle = (modelUsed, fallbackUsed, isLoading = false) => {
  if (isLoading) {
    return "analyse en cours…";
  }

  const model = String(modelUsed || "").trim();
  const hasUsableModel = Boolean(model && model.toLowerCase() !== "unknown");

  if (hasUsableModel && fallbackUsed === true) {
    return `${model} · fallback`;
  }
  if (hasUsableModel) {
    return model;
  }
  if (fallbackUsed === true) {
    return "fallback";
  }

  return "";
};

export const buildCvImportProviderMessage = ({
  success,
  provider_primary,
  provider_used,
  provider_fallback_used,
  model_used,
}) => {
  const primary = normalizeProviderName(provider_primary, "unknown");
  const used = normalizeProviderName(provider_used, primary);
  const fallbackUsed = provider_fallback_used === true;
  const model = String(model_used || "").trim();
  const hasUsableModel = Boolean(model && model.toLowerCase() !== "unknown");
  const modelSuffix = hasUsableModel ? ` (${model})` : "";

  if (success) {
    if (used === "deterministic") {
      return "Analyse IA indisponible : brouillon reconstruit localement depuis le document source.";
    }
    if (fallbackUsed && primary === "vertex_ai" && used === "google_ai") {
      return "Analyse réalisée avec Google AI (fallback automatique depuis Vertex).";
    }
    return `Analyse réalisée avec ${getProviderLabel(used)}${modelSuffix}.`;
  }

  if (primary === "vertex_ai") {
    return "Analyse IA indisponible : Vertex a échoué et aucun fallback n’a pu être utilisé.";
  }
  if (primary === "google_ai") {
    return "Analyse IA indisponible : Google AI a échoué.";
  }
  return "Analyse IA indisponible.";
};
